export interface RoomParts {
    projectId: number;
    featureId?: number | string | null;
    userStoryId?: string | null;
    workProductId: number;
    version: number;
}

/**
 * Collab room name — shared contract with the backend authorize endpoint:
 *   wp:{projectId}:{featureId|-}:{userStoryId|-}:{workProductId}:v{version}
 * Segments may not contain ':' so user story ids are sanitized.
 */
export function buildRoomName({ projectId, featureId, userStoryId, workProductId, version }: RoomParts): string {
    const feature = featureId === null || featureId === undefined || featureId === "" ? "-" : String(featureId);
    const story = userStoryId ? String(userStoryId).replace(/:/g, "_") : "-";
    return `wp:${projectId}:${feature}:${story}:${workProductId}:v${version}`;
}

/** Awareness/fragment field name for a section. */
export function sectionField(warehouseId: number | string): string {
    return `section-${warehouseId}`;
}
